import { html, ReactiveControllerHost } from 'lit';

export class LiveAnnouncer {
  private __host: ReactiveControllerHost;

  private __message = '';

  private __toggle = false;

  constructor(host: ReactiveControllerHost) {
    this.__host = host;
  }

  announce(message: string) {
    // Alternating a zero-width space makes a repeated message still count as a change, so it's re-announced.
    this.__toggle = !this.__toggle;
    this.__message = this.__toggle ? `${message}\u200b` : message;
    this.__host.requestUpdate();
  }

  render() {
    return html`
      <div class="visually-hidden" aria-live="polite">${this.__message}</div>
    `;
  }
}
